(function () {
  'use strict';

  var ICON_PLUS = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="icon-plus-toggle"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>';

  function makeAccordion(id, title, content, open) {
    return '<details id="Details-' + id + '" class="accordion-details" is="accordion-group"' + (open ? ' open aria-expanded="true"' : '') + '>' +
      '<summary class="accordion-details__summary flex items-center justify-between">' +
      '<div class="flex items-center gap-2"><h2 class="h4 inline-richtext">' + title + '</h2></div>' +
      ICON_PLUS +
      '</summary>' +
      '<div class="accordion-details__content rte text-subtext">' + content + '</div>' +
      '</details>';
  }

  function render() {
    var data = window.__ACCORDION_DATA__;
    if (!data) return;

    document.querySelectorAll('.product-accordions').forEach(function (container) {
      if (container.innerHTML.trim().length > 0) return;
      var handle = container.getAttribute('data-handle');
      var product = handle && data[handle];

      var html = '';
      if (product) {
        if (product.about) {
          html += makeAccordion('about', 'About the Product', product.about, true);
        }
        if (product.ingredients) {
          html += makeAccordion('ingredients', "What's It Made Of", product.ingredients, false);
        }
        if (product.how_to_use) {
          html += makeAccordion('how-to-use', 'How to Use', product.how_to_use, false);
        }
        if (product.why_better) {
          var fdaDisclaimer = '<div class="fda-disclaimer" style="margin-top:16px;padding-top:12px;border-top:1px solid #ddd;font-size:15px;color:#555;line-height:1.6;">' +
            '<span style="font-weight:700;font-size:16px;">* FDA Disclaimer</span><br>' +
            'These statements have not been evaluated by the Food and Drug Administration. This product is not intended to diagnose, treat, cure, or prevent any disease.' +
            '</div>';
          html += makeAccordion('why-better', "Why It's Better *", product.why_better + fdaDisclaimer, false);
        }
      }

      container.innerHTML = html;
    });
  }

  function init() {
    if (!window.__ACCORDION_DATA__) {
      setTimeout(init, 100);
      return;
    }
    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-render when quick view loads
  document.addEventListener('quick-view:loaded', function () {
    if (window.__ACCORDION_DATA__) render();
  });
})();
